import { Link } from "react-router-dom";
import PublicBreadcrumb from "@/components/public/PublicBreadcrumb";
import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";

export default function Register() {
  return (
    <div className="min-h-screen auth-grain flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg p-8 shadow-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-11 w-11 rounded-md bg-slate-900 flex items-center justify-center">
            <Shield className="h-6 w-6 text-white" strokeWidth={2} />
          </div>
          <div>
            <div className="font-display font-black text-xl">Audit Pro</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">GDPR · NIS2</div>
          </div>
        </div>
        <PublicBreadcrumb currentLabel="Registrazione" />
        <h1 className="font-display font-black text-3xl mb-2">Accesso su invito</h1>
        <p className="text-slate-500 text-sm mb-8">Gli account Audit Pro vengono creati esclusivamente dall'amministratore.</p>
        <Button asChild className="w-full h-11 bg-slate-900 hover:bg-slate-800 text-white font-medium">
          <Link to="/contact">Richiedi attivazione</Link>
        </Button>

        <p className="mt-8 text-sm text-slate-500 text-center">
          Hai già un account?{" "}
          <Link to="/auth/login" data-testid="link-login" className="text-slate-900 font-semibold hover:underline">Accedi</Link>
        </p>
        <p className="mt-3 text-xs text-center text-slate-400">
          Sei un'azienda e vuoi un piano dedicato? <Link to="/contact" className="text-slate-600 hover:text-slate-950">Richiedi attivazione</Link>
        </p>
      </div>
    </div>
  );
}
